import { lazy } from 'react';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const SystemEnvPage = lazy(() => import('@/pages/system/env'));

export const systemRoutes: RouteConfig = {
  path: '/system',
  layout: DashboardLayout,
  children: [
    {
      path: '/env',
      element: SystemEnvPage,
    },
  ],
};
